import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../../data/portfolioData';

export default function BentoProjects() {
  return (
    <section id="projects" className="mx-auto w-full max-w-7xl px-4 py-20 sm:px-6 lg:px-10">
      <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-cyan-300">Selected Work</p>
          <h2 className="font-display text-3xl font-bold text-white sm:text-5xl">Bento Project Grid</h2>
        </div>
        <p className="max-w-xl text-sm text-slate-400 sm:text-base">
          Production-driven projects with strong system design, polished UI details, and clear business utility.
        </p>
      </div>

      <div className="grid auto-rows-[260px] grid-cols-1 gap-5 md:grid-cols-3">
        {projects.map((project, index) => (
          <motion.article
            key={project.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45, delay: index * 0.06 }}
            whileHover={{ y: -6, scale: 1.01 }}
            className={`group glass-card relative overflow-hidden p-4 ${project.size}`}
          >
            <img
              src={project.image}
              alt={`${project.title} preview`}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover opacity-40 transition duration-500 group-hover:scale-105 group-hover:opacity-50"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-slate-950/10 via-slate-950/45 to-slate-950/90" />

            <div className="relative z-10 flex h-full flex-col justify-between">
              <div>
                <h3 className="font-display text-xl font-bold text-white">{project.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-300">{project.description}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {project.tech.map((tech) => (
                    <span key={tech} className="rounded-full border border-cyan-300/30 bg-cyan-300/10 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-cyan-100">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-4 flex gap-3 text-xs font-bold uppercase tracking-[0.14em]">
                {project.liveUrl ? (
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="rounded-full bg-neon px-4 py-2 text-white shadow-glow"
                  >
                    View Project
                  </a>
                ) : null}
                <a
                  href={project.repoUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-full border border-white/25 bg-white/5 px-4 py-2 text-slate-100"
                >
                  Source
                </a>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
